<script lang="ts" setup>
import SvgIllustration from '@/vue/atoms/svg-illustration.vue';
import BadgePill from '@/vue/atoms/badge-pill.vue';
import BadgeZeppelin from '@/vue/atoms/badge-zeppelin.vue';
import LazyImage from '@/vue/atoms/lazy-image.vue';
import type {UuidDTO} from '@/ts/types/dto/sign-in-dto';

defineProps<{
  title: string;
  badgeZeppelinTxt?: string;
  badgePillTxt?: string;
  downSized?: boolean;
  imageId?: UuidDTO;
}>();

</script>

<template>
  <div class="content-title-header" :class="{'content-title-header--down-sized': downSized}">
    <div class="top">
      <badge-pill v-if="badgePillTxt" theme="white" :label="badgePillTxt"/>
    </div>

    <div v-if="imageId" class="image-container" :class="{'image-container--down-sized': downSized}">
      <lazy-image :src="imageId" :width="768" class="image"/>
    </div>

    <div class="content">
      <div v-if="badgeZeppelinTxt">
        <badge-zeppelin :label="badgeZeppelinTxt"/>
      </div>
      <div class="title-row">
        <h1 class="title">
          {{ title }}
        </h1>
        <svg-illustration name="right-down-arrow.svg" inner-class="inner-right"/>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.content-title-header {
  @include q-card;
  background-color: var(--Light-Scheme-Neutral-UI-neutral-ui-20);
  color: var(--Light-Scheme-Neutral-UI-neutral-ui-80);
  padding: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 250px;
  overflow: hidden;

  @include screen-md {
    min-height: 300px;
  }

  @include screen-lg {
    min-height: 400px;
  }

  &--down-sized {
    min-height: 170px;
    @include screen-md {
      min-height: 300px;
    }
    @include screen-lg {
      min-height: 400px;
    }
  }
}

.title-row {
  display: flex;
  justify-content: space-between;
}

.title {
  @include font-display-3;
}

.top {
  position: absolute;
  top: var(--Spacing-spacing-6);
  right: var(--Spacing-spacing-5);
  z-index: 1;
  display: flex;
  justify-content: flex-end;

  @include screen-md {
    top: var(--Spacing-spacing-6);
    right: var(--Spacing-spacing-5);
  }

  @include screen-lg {
    top: var(--Spacing-spacing-6);
    right: var(--Spacing-spacing-5);
  }
}

.image-container {
  flex-shrink: 0;
}

.image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: var(--card-border-radius) var(--card-border-radius) 0 0;
  background-color: var(--Light-Scheme-Neutral-UI-neutral-ui-20);

  @include screen-md {
    height: 300px;
  }

  @include screen-lg {
    height: 400px;
  }

  .content-title-header--down-sized & {
    height: 250px;
    object-fit: contain;
    @include screen-md {
      object-fit: contain;
      height: 300px;
    }
    @include screen-lg {
      height: 400px;
    }
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--Spacing-spacing-1);
  padding: var(--Spacing-spacing-6);
}

</style>